var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.PWFieldWrapper},[_c('div',{class:[
      _vm.$style.PWTextarea,
      _vm.isFocused && _vm.$style.PWTextareaFocus,
      _vm.isError && _vm.$style.PWTextareaError,
    ],attrs:{"aria-disabled":_vm.disabled}},[_c('label',{class:[
        _vm.$style.PWTextareaPlaceholder,
        _vm.placeholderToUp && _vm.$style.PWTextareaPlaceholderToUp,
      ],attrs:{"for":_vm.id}},[_vm._v("\n      "+_vm._s(_vm.placeholder)+"\n    ")]),_vm._v(" "),_c('textarea',{ref:"ta",class:_vm.$style.PWTextareaArea,style:({
        width: _vm.width
      }),attrs:{"id":_vm.id,"disabled":_vm.disabled,"required":_vm.required,"rows":_vm.lines},domProps:{"value":_vm.value},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur,"input":_vm.handleInput}})]),_vm._v(" "),(_vm.$slots.default)?_c('div',{class:[
      _vm.$style.PWFieldTip,
      _vm.isError && _vm.$style.PWFieldTipError,
    ]},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }